import { Card, Row, Space, Tag } from "antd";
import { Content } from "antd/lib/layout/layout";
import { Steps, Button } from "antd";
import { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { ProductoVariante } from "./ProductoVariante";
import { ProductSimple } from "./ProductSimple";
import {
  GetAllAttributes,
  GetAllCategorys,
  GetAllBrands,
  GetAllTermsAttributes,
  baseurl,
  baseurlwc,
  credentials,
} from "../../api/api";
import { GetTokenProducto } from "../../api/utils";
import { ReviewProduct } from "./ReviewProduct";
import axios from "axios";
import Cookies from "js-cookie";
import { Atributes, useAttributesStore } from "./Atributes";
import { toast } from "react-toastify";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckOutlined,
  ReloadOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { create } from "zustand";

const { Step } = Steps;

const defProductConfig = {
  TipoProducto: 1,
  IdIva: 0,
  PorcentajeIva: "19%", // IVA por defecto (ver TypeIva en api/utils.js)
  ParametrizacionContableProducto: [
    { NumeroCuenta: "143506", Tipo: 0 }, // Inventario
    { NumeroCuenta: "413506", Tipo: 1 }, // Ventas
    { NumeroCuenta: "613506", Tipo: 2 }, // Costo de Ventas
    { NumeroCuenta: "622505", Tipo: 4 }, // Devolución Compras
    { NumeroCuenta: "417506", Tipo: 5 }, // Devolución Ventas
  ],
};

export const TYPE_PRODUCT = "Producto";

export const useProductStore = create((set) => ({
  type: TYPE_PRODUCT,
  isProduct: true,
  categorys: [],
  brands: [],
  data: defProductConfig,
  setType: () => set({ type: TYPE_PRODUCT, isProduct: true, data: defProductConfig }),
  setData: (data) => set((state) => ({ data: { ...state.data, ...data } })),
  setcategorys: (categorys) => set({ categorys: Array.isArray(categorys) ? categorys : [] }),
  setBrands: (brands) => set({ brands: Array.isArray(brands) ? brands : [] }),
  setCategory: (index, code) =>
    set((state) => {
      const data = Object.assign({}, state.data);
      data.ParametrizacionContableProducto[index].NumeroCuenta = code;
      return { data };
    }),
  reset: () => set({ data: defProductConfig }),
  knowName: (id, categorys) => {
    let name = categorys.filter((category) => category.id === id);
    return name[0]?.name || "";
  },
}));

// Botón para refrescar categorías y marcas; se muestra junto a esos selects.
export const ReloadCatalogButton = () => {
  const producto = useProductStore();
  const [loading, setLoading] = useState(false);

  const reload = async () => {
    setLoading(true);
    try {
      const [catsRes, brandsRes] = await Promise.all([
        GetAllCategorys(true),
        GetAllBrands(true),
      ]);
      producto.setcategorys(catsRes.data);
      producto.setBrands(brandsRes.data);
      toast.success("Categorías y marcas actualizadas");
    } catch (error) {
      toast.error("Error al actualizar: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="primary"
      icon={<ReloadOutlined />}
      loading={loading}
      onClick={reload}
      style={{ fontWeight: 500, boxShadow: "0 2px 6px rgba(24, 144, 255, 0.35)" }}
    >
      Actualizar categorías y marcas
    </Button>
  );
};

export const LayoutProducto = () => {
  const producto = useProductStore();
  const attributes = useAttributesStore();

  useEffect(() => {
    GetAllAttributes().then((res) => {
      if (!Array.isArray(res.data)) {
        toast.error(
          "Error al cargar atributos: " +
            (res.data?.message || res.problem || "respuesta inválida de WooCommerce")
        );
        return;
      }
      const formattedList = res.data.map((attr) => ({
        id: attr.id,
        name: attr.name,
      }));
      attributes.setList(formattedList);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (attributes.list.length > 0) {
      Promise.all(
        attributes.list.map((item) =>
          GetAllTermsAttributes(item.id)
            .then((res) => ({ id: item.id, terms: res.data || [] }))
            .catch((err) => {
              toast.error(`Error al cargar términos de ${item.name}: ${err.message}`);
              return { id: item.id, terms: [] };
            })
        )
      ).then((results) => {
        const groups = results.reduce((acc, { id, terms }) => {
          acc[id] = terms;
          return acc;
        }, {});
        attributes.setGroups(groups);
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes.list]);

  const [current, setCurrent] = useState(0);
  const [selected, setselected] = useState(null);
  const [controlStatusGeneral, setcontrolStatusGeneral] = useState({
    nextDisabled: true,
    loading: false,
  });
  const addProductSimple = (productstore) => {
    if (!producto.isProduct) {
      toast.error("Solo se pueden crear productos, no servicios.");
      return;
    }

    console.log('@@productstore', productstore);

    const getToken = GetTokenProducto(producto.data);
    setcontrolStatusGeneral({
      ...controlStatusGeneral,
      messagestep1: "Obteniendo token...",
      messagestep2: "Esperando respuesta...",
      loading: true,
      step: 1,
    });

    getToken.then((token) => {
      setcontrolStatusGeneral({
        ...controlStatusGeneral,
        messagestep1: "Token obtenido correctamente",
        messagestep2: "Creando producto...",
        loading: true,
        step: 2,
        status: "loading",
      });

      let { data } = token;
      if (data) {
        console.log('@@data', data);
        console.log('@@product', producto.data);

        let productotosave = {
          ...producto.data,
          Token: data,
        };

        if (selected === "2") {
          setcontrolStatusGeneral({
            ...controlStatusGeneral,
            messagestep3: "Creando producto en WooCommerce...",
            loading: true,
            step: 3,
            status: "loading",
          });

          let producttowc = {
            name: productotosave.Descripcion,
            meta_data: [
              {
                key: "referencia",
                value: productotosave.Codigo,
              },
            ],
            type: "variable",
            regular_price: `${productotosave.PrecioVentaConIva1}`,
            manage_stock: false,
            status: "pending",
            sale_price: `${productotosave.PrecioVentaConIva1}`,
            contable_codes: productotosave.ParametrizacionContableProducto,
            stock_quantity: 0,
            stock_status: "outofstock",
            categories: [
              {
                id: productotosave.IdCategoria,
              },
              {
                id: productotosave.IdSubCategoria,
              },
            ],
            brands: [
              {
                id: productotosave.IdMarca,
              },
            ],
            tags: (producto.data.tags || []).map((tag) => ({ name: tag })),
          };

          axios.post(baseurlwc + `/products?${credentials}`, { ...producttowc })
            .then((res) => {
              if (res.data.id) {
                Cookies.set("productid", res.data.id);
                Cookies.set("productname", res.data.name);
                setcontrolStatusGeneral({
                  ...controlStatusGeneral,
                  messagestep3: "Producto de WooCommerce creado correctamente",
                  step: 4,
                  status: "success",
                  loading: false,
                });
              }
            })
            .catch((error) => {
              const msg = error.response?.data?.message || error.message;
              toast.error("Error al crear el producto en WooCommerce: " + msg);
              setcontrolStatusGeneral({
                ...controlStatusGeneral,
                messagestep3: "Error: " + msg,
                step: 3,
                status: "error",
                loading: false,
              });
            });
        } else {
          axios.post(baseurl + "GuardarProductoConContabilidad", { ...productotosave })
            .then((res) => {
              setcontrolStatusGeneral({
                ...controlStatusGeneral,
                messagestep1: "Token obtenido correctamente",
                messagestep2: res.data.MensajeError,
                loading: true,
                step: res.data.Exito ? 3 : 2,
                status: res.data.Exito ? "success" : "error",
              });

              if (res.data.Exito) {
                setcontrolStatusGeneral({
                  ...controlStatusGeneral,
                  messagestep3: "Creando producto en WooCommerce...",
                  loading: true,
                  step: 3,
                  status: "loading",
                });

                let producttowc = {
                  name: productotosave.Descripcion,
                  meta_data: [
                    {
                      key: "referencia",
                      value: productotosave.Codigo,
                    },
                  ],
                  sku: res.data.CodigoBarras,
                  type: "simple",
                  regular_price: `${productotosave.PrecioVentaConIva1}`,
                  manage_stock: true,
                  contable_codes: productotosave.ParametrizacionContableProducto,
                  status: "pending",
                  sale_price: `${productotosave.PrecioVentaConIva1}`,
                  stock_quantity: 0,
                  weight: productotosave.weight,
                  dimensions: {
                    length: producto.data.dimensions.length,
                    width: producto.data.dimensions.width,
                    height: producto.data.dimensions.height,
                  },
                  stock_status: "outofstock",
                  categories: [
                    {
                      id: productotosave.IdCategoria,
                    },
                    {
                      id: productotosave.IdSubCategoria,
                    },
                  ],
                  brands: [
                    {
                      id: productotosave.IdMarca,
                    },
                  ],
                  tags: (producto.data.tags || []).map((tag) => ({ name: tag })),
                };

                axios.post(baseurlwc + `/products?${credentials}`, { ...producttowc })
                  .then((res) => {
                    if (res.data.id) {
                      Cookies.set("productid", res.data.id);
                      Cookies.set("productname", res.data.name);
                      setcontrolStatusGeneral({
                        ...controlStatusGeneral,
                        messagestep3: "Producto de WooCommerce creado correctamente",
                        step: 4,
                        status: "success",
                        finish: true,
                        loading: false,
                      });
                    }
                  });
              } else {
                toast.error(res.data.MensajeError);
              }
            });
        }
      }
    });

    setCurrent(current + 1);
  };

  useEffect(() => {
    GetAllBrands().then((res) => {
      producto.setBrands(res.data);
      console.log("Datos de GetAllBrands:", res.data);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetAllCategorys().then((res) => {
      console.log('@@categories', res.data);
      producto.setcategorys(res.data);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
    setcontrolStatusGeneral({
      ...controlStatusGeneral,
      loading: false,
    });
  };

  const renderStepsVariant = () => {
    return stepsProductVariant.map((item) => (
      <Step key={item.title} title={item.title} />
    ));
  };

  const renderSteps = () => {
    return steps.map((item) => <Step key={item.title} title={item.title} />);
  };

  const handleselectproductype = (typroduct) => {
    setselected(typroduct);
    producto.setType();
  };

  let rulesShowButtonNext = (selectedP, currentP = 1) => {
    let btnnext = false;
    let btnfinish = false;
    let btnprev = false;
    if (selectedP === "1") {
      switch (currentP) {
        case 0:
          btnnext = true;
          break;
        case 1:
          btnprev = true;
          break;
        case 2:
          btnfinish = true;
          btnprev = true;
          break;
        default:
          //
      }
    } else if (selectedP === "2") {
      switch (currentP) {
        case 0:
          btnnext = true;
          break;
        case 1:
          btnprev = true;
          break;
        case 2:
          btnnext = true;
          btnprev = true;
          break;
        case 4:
          btnfinish = true;
          break;
        default:
          //
      }
    }

    return {
      btnnext,
      btnfinish,
      btnprev,
    };
  };

  let steps = [
    {
      title: "Tipo Producto",
      content: (
        <TipoDeProducto
          handleselectproductype={handleselectproductype}
          next={next}
          selected={selected}
          setcontrolStatusGeneral={setcontrolStatusGeneral}
        />
      ),
    },
    {
      title: "Crear Producto",
      content: (
        <RenderTypeProduct
          selected={selected}
          addProductSimple={addProductSimple}
          controlStatusGeneral={controlStatusGeneral}
        />
      ),
    },
    {
      title: "Resumen",
      content: <ReviewProduct controlStatusGeneral={controlStatusGeneral} />,
    },
  ];

  let stepsProductVariant = [
    {
      title: "Tipo",
      content: (
        <TipoDeProducto
          handleselectproductype={handleselectproductype}
          next={next}
          selected={selected}
          setcontrolStatusGeneral={setcontrolStatusGeneral}
        />
      ),
    },
    {
      title: "Detalles",
      content: (
        <RenderTypeProduct
          selected={selected}
          addProductSimple={addProductSimple}
          controlStatusGeneral={controlStatusGeneral}
        />
      ),
    },
    {
      title: "Resumen",
      content: (
        <ReviewProduct controlStatusGeneral={controlStatusGeneral} isVariable />
      ),
    },
    {
      title: "Atributos",
      content: (
        <Atributes
          controlStatusGeneral={controlStatusGeneral}
          next={next}
          setcontrolStatusGeneral={setcontrolStatusGeneral}
        />
      ),
    },
    {
      title: "Variantes",
      content: (
        <ProductoVariante addProductSimple={addProductSimple} variation />
      ),
    },
  ];

  return (
    <Content
      style={{ marginTop: "20px", overflow: "initial", padding: "0 16px", marginLeft: "135px" }}
    >
      <Row justify="center">
        <Card
          style={{
            borderRadius: "16px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: "70vw",
            margin: "0 auto",
            padding: "24px",
          }}
          title={
            !selected
              ? "Crear Producto"
              : selected === "1"
              ? "Gestión Producto Simple"
              : "Gestión Producto Variable"
          }
        >
          <Steps current={current} style={{ marginBottom: "24px" }}>
            {selected === "2" ? renderStepsVariant() : renderSteps()}
          </Steps>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              minHeight: "40vh",
              marginBottom: "40px",
            }}
            className="steps-content"
          >
            {selected === "1"
              ? steps[current].content
              : stepsProductVariant[current].content}
          </div>
          <div
            className="steps-action"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            {rulesShowButtonNext(selected, current).btnfinish && (
              <Button
                icon={<CheckOutlined />}
                disabled={controlStatusGeneral.loading}
                style={{
                  height: "48px",
                  width: "120px",
                  background: "linear-gradient(90deg, #1890ff, #40c4ff)",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                  transition: "all 0.3s ease",
                  marginLeft: "auto",
                }}
                shape="round"
                type="primary"
                onClick={() => {
                  setCurrent(0);
                  setselected(null);
                  setcontrolStatusGeneral({
                    nextDisabled: true,
                    finish: false,
                  });
                  Cookies.remove("productid");
                  Cookies.remove("productname");
                  producto.reset();
                  attributes.reset();
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(24, 144, 255, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(24, 144, 255, 0.3)";
                }}
                disabledStyle={{
                  background: "#d9d9d9",
                  color: "#8c8c8c",
                  boxShadow: "none",
                  transform: "scale(1)",
                  cursor: "not-allowed",
                }}
              >
                Finalizar
              </Button>
            )}

            {rulesShowButtonNext(selected, current).btnprev && (
              <Button
                icon={<ArrowLeftOutlined />}
                style={{
                  height: "48px",
                  width: "120px",
                  background: "linear-gradient(90deg, #ff4d4f, #ff7875)",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(255, 77, 79, 0.3)",
                  transition: "all 0.3s ease",
                  marginLeft: "auto",
                }}
                danger
                shape="round"
                onClick={() => prev()}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(255, 77, 79, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(255, 77, 79, 0.3)";
                }}
              >
                Regresar
              </Button>
            )}

            {rulesShowButtonNext(selected, current).btnnext && (
              <Button
                icon={<ArrowRightOutlined />}
                disabled={controlStatusGeneral.loading}
                style={{
                  height: "48px",
                  width: "140px",
                  background: "linear-gradient(90deg, #1890ff, #40c4ff)",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: 500,
                  color: "#fff",
                  display: current === 4 ? "none" : "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(24, 144, 255, 0.2)",
                  transition: "all 0.3s ease",
                }}
                shape="round"
                type="primary"
                onClick={() => next()}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(24, 144, 255, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(24, 144, 255, 0.2)";
                }}
                disabledStyle={{
                  background: "#d9d9d9",
                  color: "#8c8c8c",
                  boxShadow: "none",
                  cursor: "not-allowed",
                }}
              >
                Siguiente
              </Button>
            )}
          </div>
        </Card>
      </Row>
    </Content>
  );
};

const PRODUCT_TYPE_OPTIONS = [
  {
    value: "1",
    title: "Producto simple",
    icon: <ShoppingOutlined />,
    description:
      "Un solo artículo, sin tallas ni colores. Se crea en ARI y en WooCommerce.",
  },
  {
    value: "2",
    title: "Producto variable",
    icon: <AppstoreOutlined />,
    description:
      "Un artículo con variantes (talla, color…). Primero se crea el producto padre en WooCommerce y luego cada variante en ARI y WooCommerce.",
  },
];

const TipoDeProducto = (props) => {
  // Al elegir el tipo se pasa directo al formulario (sin pulsar "Siguiente")
  const selectType = (value) => {
    props.handleselectproductype(value);
    props.setcontrolStatusGeneral({ nextDisabled: false });
    props.next();
  };

  return (
    <div
      style={{
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        borderRadius: "12px",
        margin: 0,
        background: "#fff",
      }}
    >
      {props.selected === null && (
        <div
          style={{
            width: "100%",
            maxWidth: 760,
            margin: "24px auto 0",
            padding: "0 16px",
            boxSizing: "border-box",
          }}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: 18,
              fontWeight: 500,
              color: "#595959",
              marginBottom: 24,
            }}
          >
            ¿Qué tipo de producto vas a crear?
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(min(240px, 100%), 1fr))",
              gap: 24,
            }}
          >
            {PRODUCT_TYPE_OPTIONS.map((opt) => (
              <div key={opt.value} style={{ minWidth: 0 }}>
                <Card
                  hoverable
                  role="button"
                  tabIndex={0}
                  onClick={() => selectType(opt.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") selectType(opt.value);
                  }}
                  style={{
                    height: "100%",
                    borderRadius: 12,
                    textAlign: "center",
                    border: "1px solid #d9d9d9",
                    overflowWrap: "anywhere",
                    maxWidth: "100%",
                    overflow: "hidden",
                  }}
                  bodyStyle={{ padding: 24 }}
                >
                  <div style={{ fontSize: 40, color: "#1890ff" }}>{opt.icon}</div>
                  <div style={{ fontSize: 18, fontWeight: 600, margin: "12px 0 8px" }}>
                    {opt.title}
                  </div>
                  <div style={{ color: "#8c8c8c" }}>{opt.description}</div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      )}

      <Row
        justify="center"
        style={{
          marginTop: "3vh",
        }}
      >
        {props.selected != null && (
          <Space
            direction="vertical"
            align="center"
            style={{
              padding: "10px 0",
            }}
          >
            <Text
              style={{
                fontSize: "22px",
                fontWeight: 600,
                color: "#595959",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
              }}
            >
              Tipo de producto a crear
            </Text>
            <img
              src="https://cdn3d.iconscout.com/3d/premium/thumb/product-5806313-4863042.png"
              alt="Producto"
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "10px",
                objectFit: "contain",
                margin: "10px 0",
                background: "none",
              }}
            />
            <Tag
              closable
              onClose={() => {
                props.handleselectproductype(null);
                props.setcontrolStatusGeneral({
                  nextDisabled: true,
                });
              }}
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "16px",
                fontWeight: 500,
                background: "linear-gradient(90deg, #1890ff, #40c4ff)",
                padding: "6px 12px",
                border: "none",
                borderRadius: "8px",
                color: "#fff",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow =
                  "0 2px 8px rgba(24, 144, 255, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              {props.selected === "1" ? "Producto Simple" : "Producto Variable"}
            </Tag>
          </Space>
        )}
      </Row>
    </div>
  );
};

const RenderTypeProduct = ({ selected, addProductSimple }) => {
  return (
    <>
      {selected === "1" ? (
        <ProductSimple addProductSimple={addProductSimple} />
      ) : (
        <ProductoVariante addProductSimple={addProductSimple} />
      )}
    </>
  );
};